<template>
    <transition name="vpd-fade">
        <div v-if="value" class="vpd-acc-overlay">
            <div class="vpd-acc-popup">
                <div class="vpd-acc-content">
                    <div class="vpd-acc-title">Lakossági számla</div>

                    <div class="vpd-acc-text">
                        Úgy érzékeltük, hogy több számlád is van. Kérjük válaszd ki a lakossági forint
                        folyószámládat, mert a kalkulátor csak ezzel tud kalkulálni.
                    </div>

                    <div class="vpd-acc-list" :class="{ 'is-scrollable': accounts.length > 1 }">
                        <button v-for="(acc, idx) in accounts" :key="acc.id" type="button" class="vpd-acc-tile"
                            @click="select(acc)">
                            <div>
                            </div>
                            <div class="vpd-acc-tile-title">
                                <div class="acc-name">{{ (acc.name || '').trim() }} - </div>
                                <div class="acc-bban">{{ ibanToDashedBban((acc.bban || '').trim()) || (acc.bban ||
                                    '').trim() }}</div>
                            </div>

                            <span class="vpd-acc-tile-border" aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "vpd-account-selector",
    props: {
        value: { type: Boolean, default: false },
        accounts: { type: Array, default: () => [] },
    },
    methods: {
        select(acc) {
            this.$emit("selected", acc);
            this.$emit("input", false);
        },
        ibanToDashedBban(iban) {
            if (!iban) return null;

            const normalized = iban.replace(/\s+/g, '');

            if (!normalized.startsWith('HU') || normalized.length !== 28) {
                return null;
            }

            const bban = normalized.slice(4); // 24 chars

            return bban.match(/.{1,8}/g).join('-');
        },
        accountLabel(acc, idx) {
            acc = acc || {}

            var name = (acc.name || '').trim()
            var rawBban = (acc.bban || '').trim()
            var shown = this.ibanToDashedBban(rawBban) || rawBban

            var label
            if (name && shown) {
                label = name + ' - ' + shown
            } else if (shown) {
                label = shown
            } else {
                label = 'Számla ' + (idx + 1)
            }

            return label
        },
    },
};
</script>

<style scoped>
/* Overlay */
.vpd-acc-overlay {
    position: fixed;
    inset: 0;
    background: rgba(69, 101, 143, 0.5);
    z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;
}

/* Popup (desktop) */
.vpd-acc-popup {
    width: max-content;
    min-width: 490px;
    height: max-content;
    max-height: 350px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 54, 101, 0.16);
    border-radius: 8px;
}

/* Content */
.vpd-acc-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 24px;
    gap: 16px;
    box-sizing: border-box;
}

.vpd-acc-title {
    width: 100%;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #0d2a50;
}

.vpd-acc-text {
    width: 100%;
    max-width: 450px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #0d2a50;
}

/* List default: NO scrollbar */
.vpd-acc-list {
    width: 100%;
    overflow: visible;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    padding: 0;
    margin: 0;
}

/* Scroll only when needed (3+ accounts) */
.vpd-acc-list.is-scrollable {
    max-height: 185px;
    overflow-y: auto;
    overflow-x: hidden;

    /* breathing room so shadows are not clipped */
    padding: 8px 12px 8px 8px;
    margin: -8px -12px -8px -8px;

    -webkit-overflow-scrolling: touch;
}

/* Tiles */
.vpd-acc-tile {
    width: max-content;
    height: max-content;
    padding: 12px 14px;
    margin-right: 10px;
    margin-left: 10px;
    background: #ffffff;
    border: none;
    cursor: pointer;

    box-shadow: 0px 2px 12px rgba(13, 42, 80, 0.12);
    border-radius: 8px;
    text-align: left;

    position: relative;
    outline: none;
}

.vpd-acc-tile-border {
    position: absolute;
    inset: 0;
    border-radius: 8px;
    border: 1px solid rgba(13, 42, 80, 0.06);
    pointer-events: none;
}

.vpd-acc-tile:hover {
    box-shadow: 0px 4px 16px rgba(13, 42, 80, 0.14);
}

.vpd-acc-tile:focus-visible {
    box-shadow: 0px 4px 16px rgba(13, 42, 80, 0.14);
}

.vpd-acc-tile-title {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #0d2a50;
    overflow-wrap: break-word;
    display: flex;
    flex-direction: row;
}

.acc-name {
    margin-right: 4px;
}

/* Mobile: bottom-sheet style */
@media (max-width: 620px) {
    .vpd-acc-overlay {
        align-items: flex-end;
        padding-bottom: 16px;
        box-sizing: border-box;
    }

    .vpd-acc-list.is-scrollable {
        max-height: 260px
    }

    .vpd-acc-popup {
        width: 90%;
        height: max-content;
        min-width: unset;
        max-height: 440px;
    }

    .vpd-acc-tile {
        width: 100%;
    }

    .vpd-acc-tile-title {
        flex-direction: column;
    }
}

/* Fade transition */
.vpd-fade-enter-active,
.vpd-fade-leave-active {
    transition: opacity 0.2s ease;
}

.vpd-fade-enter,
.vpd-fade-leave-to {
    opacity: 0;
}
</style>
